import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Instancia DEDICADA al typeahead.
// A propósito NO reutiliza utils/axiosConfig: no queremos que cada tecla dispare
// el spinner global, ni un toast de error global, ni el logout automático por un
// 403 puntual. Solo comparte baseURL e inyección de token.
const apiBusqueda = axios.create({ baseURL: 'https://api.sinterec.cl' });
apiBusqueda.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * Busca documentos por título (solo admin en el backend).
 * Recibe `signal` de RTK para cancelar la petición previa cuando el usuario sigue escribiendo.
 */
export const buscarDocumentos = createAsyncThunk(
  'busquedaDocumentos/buscar',
  async (q, { signal, rejectWithValue }) => {
    try {
      const { data } = await apiBusqueda.get('/api/documentos/search', {
        params: { q },
        signal,
      });
      // El backend responde el envelope { success, data, message }.
      return Array.isArray(data?.data) ? data.data : [];
    } catch (error) {
      // Cancelación por una búsqueda más nueva: se propaga para que RTK la marque como aborted.
      if (axios.isCancel?.(error) || error.code === 'ERR_CANCELED') throw error;
      return rejectWithValue(error.response?.data?.message || 'Error al buscar documentos.');
    }
  }
);

const busquedaDocumentosSlice = createSlice({
  name: 'busquedaDocumentos',
  initialState: {
    resultados: [],
    cargando: false,
    error: null,
    _reqId: null, // id de la petición vigente (descarta respuestas fuera de orden)
  },
  reducers: {
    limpiarResultados: (state) => {
      state.resultados = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(buscarDocumentos.pending, (state, action) => {
        state.cargando = true;
        state.error = null;
        state._reqId = action.meta.requestId;
      })
      .addCase(buscarDocumentos.fulfilled, (state, action) => {
        if (action.meta.requestId !== state._reqId) return; // llegó una respuesta vieja
        state.cargando = false;
        state.resultados = action.payload || [];
      })
      .addCase(buscarDocumentos.rejected, (state, action) => {
        if (action.meta.requestId !== state._reqId) return;
        if (action.meta.aborted) return; // cancelada por una búsqueda más nueva
        state.cargando = false;
        state.error = action.payload || 'Error al buscar documentos.';
      });
  },
});

export const { limpiarResultados } = busquedaDocumentosSlice.actions;
export default busquedaDocumentosSlice.reducer;